function calculateInstalment(e) {
	var t = Math.floor;
	e.rpm = calculateRPMFromAPR(e);
	Decimal.set({
		precision: 20
	});
	let n = new Decimal(e.totalCashPrice).sub(e.cashDeposit),
		a = new Decimal(e.rpm).dividedBy(100).plus(1),
		i = new Decimal(-n.mul(100).dividedBy(Decimal.pow(a, -e.term).sub(1).dividedBy(a - 1)).minus(.009)).dividedBy(100).toNumber();
	return 0 === e.rpm || 0 === e.apr ? (i = (t(100 * new Decimal(n).dividedBy(e.term).toNumber()) / 100).toFixed(2), i) : e.deferPeriod && 0 < e.deferPeriod ? (Decimal.set({
		precision: 6
	}), i = new Decimal(i).mul(Decimal.pow(1 + e.rpm / 100, e.deferPeriod - 1).toNumber()), i.toDecimalPlaces(2, Decimal.ROUND_UP)) : (Decimal.set({
		precision: 6
	}), i.toFixed(2))
}

function calculateRPMFromAPR(e) {
	return Decimal.set({
		precision: 6
	}), Decimal.pow(e.apr / 100 + 1, 1 / 12).minus(1).mul(1e5).dividedBy(1e3).toNumber()
}

function calculateTotalAmountPayable(e) {
	const t = calculateInstalment(e);
	return Decimal.set({
		precision: 20
	}), new Decimal(t).times(e.term).plus(e.cashDeposit).toNumber()
}

function calculateTotalChargeForCredit(e) {
	const t = calculateInstalment(e);
	if (Decimal.set({
			precision: 20
		}), 0 == e.apr) return 0;
	else {
		let n = new Decimal(t).times(e.term).plus(e.cashDeposit).toNumber().toFixed(2);
		return new Decimal(n).minus(e.totalCashPrice).toNumber().toFixed(2)
	}
}

function setAttributes(e, t) {
	for (var n in t) e.setAttribute(n, t[n])
}
var extend = function(e) {
	e = e || {};
	for (var t = 1; t < arguments.length; t++)
		if (arguments[t])
			for (var n in arguments[t]) arguments[t].hasOwnProperty(n) && (e[n] = arguments[t][n]);
	return e
};

function printNumber(e) {
	return f = parseFloat(e), isNaN(f) ? "\xA3" + e : f.toLocaleString("en-GB", {
		style: "currency",
		currency: "GBP",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	})
}

function arr_diff(e, t) {
	for (var n = [], a = [], s = 0; s < e.length; s++) n[e[s]] = !0;
	for (var s = 0; s < t.length; s++) n[t[s]] ? delete n[t[s]] : n[t[s]] = !0;
	for (var r in n) a.push(r);
	return a
}

function LightenDarkenColor(e, t) {
	var n = !1;
	"#" == e[0] && (e = e.slice(1), n = !0);
	var a = parseInt(e, 16),
		i = (a >> 16) + t;
	255 < i ? i = 255 : 0 > i && (i = 0);
	var s = (255 & a >> 8) + t;
	255 < s ? s = 255 : 0 > s && (s = 0);
	var l = (255 & a) + t;
	return 255 < l ? l = 255 : 0 > l && (l = 0), (n ? "#" : "") + (l | s << 8 | i << 16).toString(16)
}

function serialize(e) {
	if (e && "FORM" === e.nodeName) {
		var t, n, a = [];
		for (t = e.elements.length - 1; 0 <= t; --t)
			if ("" !== e.elements[t].name) switch (e.elements[t].nodeName) {
				case "INPUT":
					switch (e.elements[t].type) {
						case "text":
						case "hidden":
						case "password":
						case "button":
						case "reset":
						case "submit":
							a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
							break;
						case "checkbox":
						case "radio":
							e.elements[t].checked && a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
							break;
						case "file":
					}
					break;
				case "TEXTAREA":
					a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
					break;
				case "SELECT":
					switch (e.elements[t].type) {
						case "select-one":
							a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
							break;
						case "select-multiple":
							for (n = e.elements[t].options.length - 1; 0 <= n; --n) e.elements[t].options[n].selected && a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].options[n].value));
					}
					break;
				case "BUTTON":
					switch (e.elements[t].type) {
						case "reset":
						case "submit":
						case "button":
							a.push(e.elements[t].name + "=" + encodeURIComponent(e.elements[t].value));
					}
			}
		return a.join("&")
	}
}! function(n, t) {
	"object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("rangeSlider", [], t) : "object" == typeof exports ? exports.rangeSlider = t() : n.rangeSlider = t()
}(window, function() {
	return function(a) {
		function r(n) {
			if (i[n]) return i[n].exports;
			var t = i[n] = {
				i: n,
				l: !1,
				exports: {}
			};
			return a[n].call(t.exports, t, t.exports, r), t.l = !0, t.exports
		}
		var i = {};
		return r.m = a, r.c = i, r.d = function(n, t, e) {
			r.o(n, t) || Object.defineProperty(n, t, {
				enumerable: !0,
				get: e
			})
		}, r.r = function(e) {
			"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
				value: "Module"
			}), Object.defineProperty(e, "__esModule", {
				value: !0
			})
		}, r.t = function(a, s) {
			if (1 & s && (a = r(a)), 8 & s) return a;
			if (4 & s && "object" == typeof a && a && a.__esModule) return a;
			var t = Object.create(null);
			if (r.r(t), Object.defineProperty(t, "default", {
					enumerable: !0,
					value: a
				}), 2 & s && "string" != typeof a)
				for (var i in a) r.d(t, i, function(e) {
					return a[e]
				}.bind(null, i));
			return t
		}, r.n = function(n) {
			var t = n && n.__esModule ? function() {
				return n.default
			} : function() {
				return n
			};
			return r.d(t, "a", t), t
		}, r.o = function(n, t) {
			return Object.prototype.hasOwnProperty.call(n, t)
		}, r.p = "", r(r.s = 1)
	}([function(a, t) {
		"use strict";
		Object.defineProperty(t, "__esModule", {
			value: !0
		}), t.uuid = function() {
			var e = function() {
				return Math.floor(65536 * (1 + Math.random())).toString(16).substring(1)
			};
			return e() + e() + "-" + e() + "-" + e() + "-" + e() + "-" + e() + e() + e()
		}, t.delay = function(a, t) {
			for (var e = arguments.length, i = Array(2 < e ? e - 2 : 0), n = 2; n < e; n++) i[n - 2] = arguments[n];
			return setTimeout(function() {
				return a.apply(null, i)
			}, t)
		}, t.debounce = function(a) {
			var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 100;
			return function() {
				for (var s = arguments.length, t = Array(s), e = 0; e < s; e++) t[e] = arguments[e];
				return a.debouncing || (a.lastReturnVal = a.apply(window, t), a.debouncing = !0), clearTimeout(a.debounceTimeout), a.debounceTimeout = setTimeout(function() {
					a.debouncing = !1
				}, n), a.lastReturnVal
			}
		};
		var e = t.isString = function(e) {
				return e === "" + e
			},
			i = (t.isArray = function(e) {
				return "[object Array]" === Object.prototype.toString.call(e)
			}, t.isNumberLike = function(n) {
				return null != n && (e(n) && isFinite(parseFloat(n)) || isFinite(n))
			});
		t.getFirsNumberLike = function() {
			for (var a = arguments.length, t = Array(a), e = 0; e < a; e++) t[e] = arguments[e];
			if (!t.length) return null;
			for (var r = 0, l = t.length; r < l; r++)
				if (i(t[r])) return t[r];
			return null
		}, t.isObject = function(e) {
			return "[object Object]" === Object.prototype.toString.call(e)
		}, t.simpleExtend = function(a, t) {
			var e = {};
			for (var i in a) e[i] = a[i];
			for (var n in t) e[n] = t[n];
			return e
		}, t.between = function(n, t, e) {
			return n < t ? t : e < n ? e : n
		}
	}, function(u, t, e) {
		"use strict";

		function i(n) {
			if (n && n.__esModule) return n;
			var t = {};
			if (null != n)
				for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
			return t.default = n, t
		}
		Object.defineProperty(t, "__esModule", {
			value: !0
		});
		var s = function() {
				function a(a, t) {
					for (var e, s = 0; s < t.length; s++) e = t[s], e.enumerable = e.enumerable || !1, e.configurable = !0, "value" in e && (e.writable = !0), Object.defineProperty(a, e.key, e)
				}
				return function(n, t, e) {
					return t && a(n.prototype, t), e && a(n, e), n
				}
			}(),
			p = i(e(2)),
			l = i(e(0));
		e(3);
		var c = /\/[\n\t]\//g,
			m = p.supportsRange(),
			d = {
				polyfill: !0,
				root: document,
				rangeClass: "rangeSlider",
				disabledClass: "rangeSlider--disabled",
				fillClass: "rangeSlider__fill",
				bufferClass: "rangeSlider__buffer",
				handleClass: "rangeSlider__handle",
				startEvent: ["mousedown", "touchstart", "pointerdown"],
				moveEvent: ["mousemove", "touchmove", "pointermove"],
				endEvent: ["mouseup", "touchend", "pointerup"],
				min: null,
				max: null,
				step: null,
				value: null,
				buffer: null,
				stick: null,
				borderRadius: 10,
				vertical: !1
			},
			n = !1,
			o = function() {
				function u(a, t) {
					! function(n, t) {
						if (!(n instanceof t)) throw new TypeError("Cannot call a class as a function")
					}(this, u);
					var e, c, b;
					if (u.instances.push(this), this.element = a, this.options = l.simpleExtend(d, t), this.polyfill = this.options.polyfill, this.vertical = this.options.vertical, this.onInit = this.options.onInit, this.onSlide = this.options.onSlide, this.onSlideStart = this.options.onSlideStart, this.onSlideEnd = this.options.onSlideEnd, this.onSlideEventsCount = -1, this.isInteractsNow = !1, this.needTriggerEvents = !1, this._addVerticalSlideScrollFix(), this.polyfill || !m) {
						this.options.buffer = this.options.buffer || parseFloat(this.element.getAttribute("data-buffer")), this.identifier = "js-rangeSlider-" + l.uuid(), this.min = l.getFirsNumberLike(this.options.min, parseFloat(this.element.getAttribute("min")), 0), this.max = l.getFirsNumberLike(this.options.max, parseFloat(this.element.getAttribute("max")), 100), this.value = l.getFirsNumberLike(this.options.value, this.element.value, parseFloat(this.element.value || this.min + (this.max - this.min) / 2)), this.step = l.getFirsNumberLike(this.options.step, parseFloat(this.element.getAttribute("step")) || (e = 1)), this.percent = null, l.isArray(this.options.stick) && 1 <= this.options.stick.length ? this.stick = this.options.stick : (c = this.element.getAttribute("stick")) && 1 <= (b = c.split(" ")).length && (this.stick = b.map(parseFloat)), this.stick && 1 === this.stick.length && this.stick.push(1.5 * this.step), this._updatePercentFromValue(), this.toFixed = this._toFixed(this.step);
						var v;
						this.container = document.createElement("div"), p.addClass(this.container, this.options.fillClass), v = this.vertical ? this.options.fillClass + "__vertical" : this.options.fillClass + "__horizontal", p.addClass(this.container, v), this.handle = document.createElement("div"), p.addClass(this.handle, this.options.handleClass), v = this.vertical ? this.options.handleClass + "__vertical" : this.options.handleClass + "__horizontal", p.addClass(this.handle, v), this.range = document.createElement("div"), p.addClass(this.range, this.options.rangeClass), this.range.id = this.identifier;
						var g = a.getAttribute("title");
						g && 0 < g.length && this.range.setAttribute("title", g), this.options.bufferClass && (this.buffer = document.createElement("div"), p.addClass(this.buffer, this.options.bufferClass), this.range.appendChild(this.buffer), v = this.vertical ? this.options.bufferClass + "__vertical" : this.options.bufferClass + "__horizontal", p.addClass(this.buffer, v)), this.range.appendChild(this.container), this.range.appendChild(this.handle), v = this.vertical ? this.options.rangeClass + "__vertical" : this.options.rangeClass + "__horizontal", p.addClass(this.range, v), l.isNumberLike(this.options.value) && (this._setValue(this.options.value, !0), this.element.value = this.options.value), l.isNumberLike(this.options.buffer) && this.element.setAttribute("data-buffer", this.options.buffer), l.isNumberLike(this.options.min) && this.element.setAttribute("min", "" + this.min), l.isNumberLike(this.options.max), this.element.setAttribute("max", "" + this.max), (l.isNumberLike(this.options.step) || e) && this.element.setAttribute("step", "" + this.step), p.insertAfter(this.element, this.range), p.setCss(this.element, {
							position: "absolute",
							width: "1px",
							height: "1px",
							overflow: "hidden",
							opacity: "0"
						}), this._handleDown = this._handleDown.bind(this), this._handleMove = this._handleMove.bind(this), this._handleEnd = this._handleEnd.bind(this), this._startEventListener = this._startEventListener.bind(this), this._changeEventListener = this._changeEventListener.bind(this), this._handleResize = this._handleResize.bind(this), this._init(), window.addEventListener("resize", this._handleResize, !1), p.addEventListeners(this.options.root, this.options.startEvent, this._startEventListener), this.element.addEventListener("change", this._changeEventListener, !1)
					}
				}
				return s(u, [{
					key: "update",
					value: function(n, t) {
						return t && (this.needTriggerEvents = !0), l.isObject(n) && (l.isNumberLike(n.min) && (this.element.setAttribute("min", "" + n.min), this.min = n.min), l.isNumberLike(n.max) && (this.element.setAttribute("max", "" + n.max), this.max = n.max), l.isNumberLike(n.step) && (this.element.setAttribute("step", "" + n.step), this.step = n.step, this.toFixed = this._toFixed(n.step)), l.isNumberLike(n.buffer) && this._setBufferPosition(n.buffer), l.isNumberLike(n.value) && this._setValue(n.value)), this._update(), this.onSlideEventsCount = 0, this.needTriggerEvents = !1, this
					}
				}, {
					key: "destroy",
					value: function() {
						var n = this;
						p.removeAllListenersFromEl(this, this.options.root), window.removeEventListener("resize", this._handleResize, !1), this.element.removeEventListener("change", this._changeEventListener, !1), this.element.style.cssText = "", delete this.element.rangeSlider, this.range && this.range.parentNode.removeChild(this.range), (u.instances = u.instances.filter(function(e) {
							return e !== n
						})).some(function(e) {
							return e.vertical
						}) || this._removeVerticalSlideScrollFix()
					}
				}, {
					key: "_toFixed",
					value: function(e) {
						return (e + "").replace(".", "").length - 1
					}
				}, {
					key: "_init",
					value: function() {
						this.onInit && "function" == typeof this.onInit && this.onInit(), this._update(!1)
					}
				}, {
					key: "_updatePercentFromValue",
					value: function() {
						this.percent = (this.value - this.min) / (this.max - this.min)
					}
				}, {
					key: "_startEventListener",
					value: function(a, t) {
						var e = this,
							i = a.target,
							n = !1;
						(1 === a.which || "touches" in a) && (p.forEachAncestors(i, function(a) {
							return n = a.id === e.identifier && !p.hasClass(a, e.options.disabledClass)
						}, !0), n && this._handleDown(a, t))
					}
				}, {
					key: "_changeEventListener",
					value: function(a, t) {
						if (!t || t.origin !== this.identifier) {
							var e = a.target.value,
								i = this._getPositionFromValue(e);
							this._setPosition(i)
						}
					}
				}, {
					key: "_update",
					value: function(n) {
						var t = this.vertical ? "offsetHeight" : "offsetWidth";
						this.handleSize = p.getDimension(this.handle, t), this.rangeSize = p.getDimension(this.range, t), this.maxHandleX = this.rangeSize - this.handleSize, this.grabX = this.handleSize / 2, this.position = this._getPositionFromValue(this.value), this.element.disabled ? p.addClass(this.range, this.options.disabledClass) : p.removeClass(this.range, this.options.disabledClass), this._setPosition(this.position), this.options.bufferClass && this.options.buffer && this._setBufferPosition(this.options.buffer), this._updatePercentFromValue(), !1 !== n && p.triggerEvent(this.element, "change", {
							origin: this.identifier
						})
					}
				}, {
					key: "_addVerticalSlideScrollFix",
					value: function() {
						this.vertical && !n && (document.addEventListener("touchmove", u._touchMoveScrollHandler, {
							passive: !1
						}), n = !0)
					}
				}, {
					key: "_removeVerticalSlideScrollFix",
					value: function() {
						document.removeEventListener("touchmove", u._touchMoveScrollHandler), n = !1
					}
				}, {
					key: "_handleResize",
					value: function() {
						var e = this;
						return l.debounce(function() {
							l.delay(function() {
								e._update()
							}, 300)
						}, 50)()
					}
				}, {
					key: "_handleDown",
					value: function(a) {
						if (this.isInteractsNow = !0, a.preventDefault(), p.addEventListeners(this.options.root, this.options.moveEvent, this._handleMove), p.addEventListeners(this.options.root, this.options.endEvent, this._handleEnd), !(-1 < (" " + a.target.className + " ").replace(c, " ").indexOf(this.options.handleClass))) {
							var t = this.range.getBoundingClientRect(),
								e = this._getRelativePosition(a),
								i = this.vertical ? t.bottom : t.left,
								n = this._getPositionFromNode(this.handle) - i,
								s = e - this.grabX;
							this._setPosition(s), n <= e && e < n + 2 * this.options.borderRadius && (this.grabX = e - n), this._updatePercentFromValue()
						}
					}
				}, {
					key: "_handleMove",
					value: function(n) {
						var t = this._getRelativePosition(n);
						this.isInteractsNow = !0, n.preventDefault(), this._setPosition(t - this.grabX)
					}
				}, {
					key: "_handleEnd",
					value: function(e) {
						e.preventDefault(), p.removeEventListeners(this.options.root, this.options.moveEvent, this._handleMove), p.removeEventListeners(this.options.root, this.options.endEvent, this._handleEnd), p.triggerEvent(this.element, "change", {
							origin: this.identifier
						}), (this.isInteractsNow || this.needTriggerEvents) && (this.onSlideEnd && "function" == typeof this.onSlideEnd && this.onSlideEnd(this.value, this.percent, this.position), this.vertical && (u.slidingVertically = !1)), this.onSlideEventsCount = 0, this.isInteractsNow = !1
					}
				}, {
					key: "_setPosition",
					value: function(a) {
						var t, o, d, p, c = this._getValueFromPosition(l.between(a, 0, this.maxHandleX));
						this.stick && ((d = c % (p = this.stick[0])) < (o = this.stick[1] || .1) ? c -= d : Math.abs(p - d) < o && (c = c - d + p)), t = this._getPositionFromValue(c), this.vertical ? (this.container.style.height = t + this.grabX + "px", this.handle.style.webkitTransform = "translateY(-" + t + "px)", this.handle.style.msTransform = "translateY(-" + t + "px)", this.handle.style.transform = "translateY(-" + t + "px)") : (this.container.style.width = t + this.grabX + "px", this.handle.style.webkitTransform = "translateX(" + t + "px)", this.handle.style.msTransform = "translateX(" + t + "px)", this.handle.style.transform = "translateX(" + t + "px)"), this._setValue(c), this.position = t, this.value = c, this._updatePercentFromValue(), (this.isInteractsNow || this.needTriggerEvents) && (this.onSlideStart && "function" == typeof this.onSlideStart && 0 === this.onSlideEventsCount && this.onSlideStart(this.value, this.percent, this.position), this.onSlide && "function" == typeof this.onSlide && this.onSlide(this.value, this.percent, this.position), this.vertical && (u.slidingVertically = !0)), this.onSlideEventsCount++
					}
				}, {
					key: "_setBufferPosition",
					value: function(a) {
						var r = !0;
						if (isFinite(a)) a = parseFloat(a);
						else {
							if (!l.isString(a)) return void console.warn("New position must be XXpx or XX%");
							0 < a.indexOf("px") && (r = !1), a = parseFloat(a)
						}
						if (isNaN(a)) console.warn("New position is NaN");
						else if (this.options.bufferClass) {
							var o = r ? a : 100 * (a / this.rangeSize);
							0 > o && (o = 0), 100 < o && (o = 100), this.options.buffer = o;
							var d = 100 * (this.options.borderRadius / this.rangeSize),
								n = o - d;
							0 > n && (n = 0), this.vertical ? (this.buffer.style.height = n + "%", this.buffer.style.bottom = .5 * d + "%") : (this.buffer.style.width = n + "%", this.buffer.style.left = .5 * d + "%"), this.element.setAttribute("data-buffer", o)
						} else console.warn("You disabled buffer, it's className is empty")
					}
				}, {
					key: "_getPositionFromNode",
					value: function(n) {
						for (var a = this.vertical ? this.maxHandleX : 0; null !== n;) a += this.vertical ? n.offsetTop : n.offsetLeft, n = n.offsetParent;
						return a
					}
				}, {
					key: "_getRelativePosition",
					value: function(a) {
						var t = this.range.getBoundingClientRect(),
							e = this.vertical ? t.bottom : t.left,
							i = 0,
							r = this.vertical ? "pageY" : "pageX";
						return void 0 === a[r] ? void 0 === a.originalEvent ? a.touches && a.touches[0] && void 0 !== a.touches[0][r] ? i = a.touches[0][r] : !a.currentPoint || void 0 === a.currentPoint.x && void 0 === a.currentPoint.y || (i = this.vertical ? a.currentPoint.y : a.currentPoint.x) : void 0 === a.originalEvent[r] ? a.originalEvent.touches && a.originalEvent.touches[0] && void 0 !== a.originalEvent.touches[0][r] && (i = a.originalEvent.touches[0][r]) : i = a.originalEvent[r] : i = a.touches && a.touches.length ? a.touches[0][r] : a[r], this.vertical && (i -= window.pageYOffset), this.vertical ? e - i : i - e
					}
				}, {
					key: "_getPositionFromValue",
					value: function(n) {
						var t = (n - this.min) / (this.max - this.min) * this.maxHandleX;
						return isNaN(t) ? 0 : t
					}
				}, {
					key: "_getValueFromPosition",
					value: function(n) {
						var t = n / (this.maxHandleX || 1),
							e = this.step * Math.round(t * (this.max - this.min) / this.step) + this.min;
						return +e.toFixed(this.toFixed)
					}
				}, {
					key: "_setValue",
					value: function(n, t) {
						(n !== this.value || t) && (this.element.value = n, this.value = n, p.triggerEvent(this.element, "input", {
							origin: this.identifier
						}))
					}
				}], [{
					key: "create",
					value: function(n, a) {
						var i = function(n) {
							var t = n.rangeSlider;
							t || (t = new u(n, a), n.rangeSlider = t)
						};
						n.length ? Array.prototype.slice.call(n).forEach(function(e) {
							i(e)
						}) : i(n)
					}
				}, {
					key: "_touchMoveScrollHandler",
					value: function(e) {
						u.slidingVertically && e.preventDefault()
					}
				}]), u
			}();
		(t.default = o).version = "0.4.11", o.dom = p, o.functions = l, o.instances = [], o.slidingVertically = !1, u.exports = t.default
	}, function(d, t, e) {
		"use strict";
		Object.defineProperty(t, "__esModule", {
			value: !0
		}), t.supportsRange = t.removeAllListenersFromEl = t.removeEventListeners = t.addEventListeners = t.insertAfter = t.triggerEvent = t.forEachAncestors = t.removeClass = t.addClass = t.hasClass = t.setCss = t.getDimension = t.getHiddenParentNodes = t.isHidden = t.detectIE = void 0;
		var u = function(n) {
				{
					if (n && n.__esModule) return n;
					var t = {};
					if (null != n)
						for (var e in n) Object.prototype.hasOwnProperty.call(n, e) && (t[e] = n[e]);
					return t.default = n, t
				}
			}(e(0)),
			s = "eventListenerList",
			i = (t.detectIE = function() {
				var a = window.navigator.userAgent,
					t = a.indexOf("MSIE ");
				if (0 < t) return parseInt(a.substring(t + 5, a.indexOf(".", t)), 10);
				if (0 < a.indexOf("Trident/")) {
					var e = a.indexOf("rv:");
					return parseInt(a.substring(e + 3, a.indexOf(".", e)), 10)
				}
				var i = a.indexOf("Edge/");
				return 0 < i && parseInt(a.substring(i + 5, a.indexOf(".", i)), 10)
			})(),
			n = window.PointerEvent && !i && {
				passive: !1
			},
			r = t.isHidden = function(e) {
				return 0 === e.offsetWidth || 0 === e.offsetHeight || !1 === e.open
			},
			p = t.getHiddenParentNodes = function(n) {
				for (var t = [], e = n.parentNode; e && r(e);) t.push(e), e = e.parentNode;
				return t
			},
			a = (t.getDimension = function(d, t) {
				var e = p(d),
					i = e.length,
					n = [],
					s = d[t],
					u = function(e) {
						void 0 !== e.open && (e.open = !e.open)
					};
				if (i) {
					for (var o = 0; o < i; o++) n.push({
						display: e[o].style.display,
						height: e[o].style.height,
						overflow: e[o].style.overflow,
						visibility: e[o].style.visibility
					}), e[o].style.display = "block", e[o].style.height = "0", e[o].style.overflow = "hidden", e[o].style.visibility = "hidden", u(e[o]);
					s = d[t];
					for (var c = 0; c < i; c++) u(e[c]), e[c].style.display = n[c].display, e[c].style.height = n[c].height, e[c].style.overflow = n[c].overflow, e[c].style.visibility = n[c].visibility
				}
				return s
			}, t.setCss = function(n, t) {
				for (var e in t) n.style[e] = t[e];
				return n.style
			}, t.hasClass = function(n, t) {
				return new RegExp(" " + t + " ").test(" " + n.className + " ")
			});
		t.addClass = function(n, t) {
			a(n, t) || (n.className += " " + t)
		}, t.removeClass = function(n, t) {
			var e = " " + n.className.replace(/[\t\r\n]/g, " ") + " ";
			if (a(n, t)) {
				for (; 0 <= e.indexOf(" " + t + " ");) e = e.replace(" " + t + " ", " ");
				n.className = e.replace(/^\s+|\s+$/g, "")
			}
		}, t.forEachAncestors = function(n, a, e) {
			for (e && a(n); n.parentNode && !a(n);) n = n.parentNode;
			return n
		}, t.triggerEvent = function(a, t, s) {
			if (!u.isString(t)) throw new TypeError("event name must be String");
			if (!(a instanceof HTMLElement)) throw new TypeError("element must be HTMLElement");
			t = t.trim();
			var i = document.createEvent("CustomEvent");
			i.initCustomEvent(t, !1, !1, s), a.dispatchEvent(i)
		}, t.insertAfter = function(n, t) {
			return n.parentNode.insertBefore(t, n.nextSibling)
		}, t.addEventListeners = function(a, e, r) {
			e.forEach(function(e) {
				a[s] || (a[s] = {}), a[s][e] || (a[s][e] = []), a.addEventListener(e, r, n), 0 > a[s][e].indexOf(r) && a[s][e].push(r)
			})
		}, t.removeEventListeners = function(a, e, i) {
			e.forEach(function(n) {
				var t;
				a.removeEventListener(n, i, !1), a[s] && a[s][n] && -1 < (t = a[s][n].indexOf(i)) && a[s][n].splice(t, 1)
			})
		}, t.removeAllListenersFromEl = function(a, e) {
			function t(e) {
				e === a._startEventListener && this.el.removeEventListener(this.eventName, e, !1)
			}
			if (e[s]) {
				for (var n in e[s]) e[s][n].forEach(t, {
					eventName: n,
					el: e
				});
				e[s] = {}
			}
		}, t.supportsRange = function() {
			var e = document.createElement("input");
			return e.setAttribute("type", "range"), "text" !== e.type
		}
	}, function() {}])
});

function initSliders(e, t, n) {
	let a = document.querySelector("#amount");
	rangeSlider.create(e, {
		polyfill: !0,
		root: document,
		rangeClass: "rangeSlider",
		disabledClass: "rangeSlider--disabled",
		fillClass: "rangeSlider__fill",
		bufferClass: "rangeSlider__buffer",
		handleClass: "rangeSlider__handle",
		startEvent: ["mousedown", "touchstart", "pointerdown"],
		moveEvent: ["mousemove", "touchmove", "pointermove"],
		endEvent: ["mouseup", "touchend", "pointerup"],
		vertical: !1,
		min: parseInt(n.minLoan),
		max: parseInt(n.maxLoan),
		step: null,
		value: a.value,
		buffer: null,
		stick: null,
		borderRadius: 10,
		onSlide: () => {},
		onSlideEnd: function(e) {
			updateAmount(e, n)
		}
	});
	let i = document.querySelector("#deposit");
	rangeSlider.create(t, {
		polyfill: !0,
		root: document,
		rangeClass: "rangeSlider",
		disabledClass: "rangeSlider--disabled",
		fillClass: "rangeSlider__fill",
		bufferClass: "rangeSlider__buffer",
		handleClass: "rangeSlider__handle",
		startEvent: ["mousedown", "touchstart", "pointerdown"],
		moveEvent: ["mousemove", "touchmove", "pointermove"],
		endEvent: ["mouseup", "touchend", "pointerup"],
		vertical: !1,
		min: 0,
		max: a.value - n.minLoan,
		step: 1,
		value: 0,
		stick: null,
		borderRadius: 10,
		onSlide: e => {
			i.value = e
		},
		onSlideEnd: function(e) {
			updateDeposit(e, n)
		}
	}), i.addEventListener("change", function() {
		let e = document.querySelector("#depositSlider");
		setSlider(e, i.value)
	})
}

function financeCalculator(e) {
	loadConfigJSON(e)
}

function mergeSettings(e, t) {
	let n = {
		debug: !1,
		sliders: !1,
		colours: {
			primary: "#7D3CFF"
		},
		classes: {
			buttons: "pbf_button",
			button_wrapper: "pbf_button_wrapper",
			button_list: "pbf_button_list",
			inputs: "pbf_input",
			input_wrapper: "pbf_input_wrapper",
			labels: "pbf_label",
			results_box: "pbf_results"
		},
		labels: {
			amount: "Enter the amount you would like to spend",
			deposit: "Enter the amount you would like to deposit",
			service: "Select a finance service",
			term: "Repayment term",
			deferralterm: "Deferral period",
			results: "Finance Summary"
		}
	};
	n.services = e.services, n.retailer = e.retailer, n.limits = e.limits, t.classes && (t.classes = extend({}, n.classes, t.classes)), t.colours && (t.colours = extend({}, n.colours, t.colours));
	let a = extend({}, n, t);
	a.colours.darker || (a.colours.darker = LightenDarkenColor(a.colours.primary, -50));
	let i = document.querySelector(a.target);
	a.loan_amount_target && (a.loanAmountTarget = a.loan_amount_target), t.finance_button && (a.financeButton = t.finance_button), t.finance_js_button && (a.financeJsButton = t.finance_js_button), i ? checkRepExample(t.rep_example) && (a.colours && createStyleMarkup(a), a.targetElement = i, createCalculatorMarkup(rebuildSettings(a, "0"))) : console.log("Please define a valid target container for the Finance Calculator")
}

function checkRepExample(e) {
	const t = Object.keys(e);
	let n = arr_diff(t, ["cash_price", "deposit", "loan_amount", "apr", "interest_rate", "term", "instalment_amount", "total_term", "credit_charge", "total_amount_payable"]);
	return !(0 != n.length) || void(console.log("Calculator could not be loaded:"), n.forEach(e => console.log("Representative example value missing: " + e)))
}

function createStyleMarkup(e) {
	var t = e.target + " .rangeSlider__fill, " + e.target + " .pbf_button:hover, " + e.target + " .pbf_button.active {background-color:" + e.colours.primary + "; border-color:" + e.colours.primary + "; color:white;} " + e.target + " .pbf_button, " + e.target + " .pbf_button:focus{background-color:lightgray; color:black;}" + e.target + " .pbf_button{color:#212529;} " + e.target + " .dark-border{border-color:" + e.colours.darker + ";} .term-section label.disabled{background-color:#565656 !important; color:lightgray !important; cursor:not-allowed;}",
		n = document.createElement("style");
	n.innerHTML = t;
	let a = document.querySelector(e.target);
	a.after(n)
}

function rebuildSettings(e, t) {
	service = Object.keys(e.services)[t];
	let n = {
		debug: e.debug,
		sliders: e.sliders,
		colours: e.colours,
		classes: e.classes,
		target: e.target,
		targetElement: e.targetElement,
		loanAmountTarget: e.loanAmountTarget,
		financeButton: e.financeButton,
		financeJsButton: e.financeJsButton,
		labels: e.labels,
		rep_example: e.rep_example,
		retailer: e.retailer,
		apr: e.services[service].apr,
		terms: e.services[service].terms,
		deferralterms: e.services[service].deferralterms,
		maxLoan: e.limits.maxLoan,
		minDeposit: e.limits.minDeposit,
		maxDeposit: e.limits.maxDeposit,
		minLoan: e.limits.minLoan,
		selectedService: t,
		serviceFirst: e.serviceFirst,
		services: e.services,
		limits: e.limits
	};
	return window.PBF_Calc = n, n
}

function createCalculatorMarkup(t) {
	let n = document.querySelector("#pbf_calculator"),
		a = null;
	if (t.loanAmountTarget) {
		a = new Decimal(document.querySelector(t.loanAmountTarget).innerText.replace(/[^0-9.]/g, "")).toFixed(2);
		var i = 0;
		document.getElementById("amount") && (i = document.getElementById("amount").value), setInterval(function() {
			var e = new Decimal(document.querySelector(t.loanAmountTarget).innerText.replace(/[^0-9.]/g, "")).toFixed(2);
			i != e && (i = e, document.getElementById("amount").value = e, document.getElementById("amountPreset").innerHTML = printNumber(e), submitForm(t))
		}, 250)
	}
	if (null != a && a < parseFloat(t.minLoan)) return;
	let s = document.createElement("FORM");
	s.setAttribute("id", "pbf_calculator");
	let r = t.targetElement,
		l = document.createElement("div");
	l.className = "pbf_form_group";
	let o = [],
		d = document.createElement("h2");
	d.innerHTML = "Finance Calculator", s.appendChild(d), o.service = l.cloneNode(!0), o.service.classList.add("service-section");
	let u = document.createElement("label"),
		p = document.createElement("div");
	p.id = "services";
	let c = Object.keys(t.services).length;
	if (sessionStorage.getItem("pbf_service") && (t.selectedService = sessionStorage.getItem("pbf_service"), sessionStorage.removeItem("pbf_service")), 1 < c && (u.innerHTML = t.labels.service, t.classes.button_list && p.setAttribute("class", t.classes.button_list), t.services && Object.keys(t.services).forEach(function(e, n) {
			if (n == t.selectedService) var a = !0;
			else var a = !1;
			let i = document.createElement("input");
			setAttributes(i, {
				name: "service",
				type: "radio",
				value: n,
				id: "pbf_finance_service_" + n,
				style: "display:none;"
			}), i.onclick = function(e) {
				updateService(e.srcElement, t)
			};
			let s = document.createElement("label");
			s.setAttribute("for", "pbf_finance_service_" + n), t.classes.buttons && s.setAttribute("class", t.classes.buttons), s.innerHTML = e, s.appendChild(i), a && (i.setAttribute("checked", "checked"), s.classList.add("active"));
			let r = document.createElement("div");
			t.classes.button_wrapper && r.classList.add("pbf_button_wrapper"), r.appendChild(s), p.appendChild(r)
		}), o.service.appendChild(u), o.service.appendChild(p)), o.amount = l.cloneNode(!0), o.amount.classList.add("amount-section"), !a) {
		let e = document.createElement("label");
		e.innerHTML = t.labels.amount, o.amount.appendChild(e)
	}
	if (!a) {
		let e = document.createElement("span");
		e.classList.add("minMax"), e.innerHTML = "(Minimum Loan Amount: <span class='min'>" + printNumber(t.minLoan) + "</span> - Maximum Loan Amount: " + printNumber(t.maxLoan) + ")", o.amount.appendChild(e)
	}
	if (a) {
		let e = document.createElement("span");
		e.classList.add("amountPreset"), e.innerHTML = "Finance Calculation for your <span class='amountPreset'><strong id=\"amountPreset\">" + printNumber(a) + "</strong></span> order", o.amount.appendChild(e)
	}
	let m = document.createElement("span");
	m.classList.add("pbf_error_message"), m.id = "pbf_amount_error";
	let b = document.createElement("div");
	b.classList.add("amount_row");
	let v = document.createElement("input");
	n ? (depositValue = n.elements[1].value, amountValue = n.elements[0].value) : (amountValue = null, depositValue = null), null == depositValue && sessionStorage.getItem("pbf_depositResults") && (depositValue = new Decimal(sessionStorage.getItem("pbf_depositResults").replace(/[^0-9.]/g, "")).toFixed(2)), amountAttributes = {
		name: "amount",
		id: "amount",
		type: "number",
		min: 0,
		step: "0.01",
		value: amountValue
	}, a && (amountAttributes.value = a, b.style.display = "none"), setAttributes(v, amountAttributes);
	let g = document.createElement("label");
	if (g.innerHTML = "\xA3", g.setAttribute("for", "amount"), g.appendChild(v), t.classes.input_wrapper && g.setAttribute("class", t.classes.input_wrapper), v.addEventListener("change", function() {
			updateAmount(v.value, t)
		}), b.appendChild(g), b.appendChild(m), o.amount.appendChild(b), t.sliders) {
		let e = document.createElement("label");
		e.innerHTML = "Alternatively, use the slider to enter loan amount", o.amount.appendChild(e);
		let n = document.createElement("input");
		setAttributes(n, {
			name: "amountSlider",
			id: "amountSlider",
			type: "range",
			step: "1",
			min: t.minLoan,
			max: t.maxLoan
		}), o.amount.appendChild(n);
		let a = document.createElement("span");
		a.classList.add("rangeLabels"), a.innerHTML = "<span>" + printNumber(t.minLoan) + "</span><span>" + printNumber((parseInt(t.minLoan) + parseInt(t.maxLoan)) / 2) + "</span><span>" + printNumber(t.maxLoan) + "</span>", o.amount.appendChild(a)
	}
	o.deposit = l.cloneNode(!0), o.deposit.classList.add("deposit-section");
	let h = document.createElement("label");
	h.innerHTML = t.labels.deposit, o.deposit.appendChild(h);
	let _ = document.createElement("input"),
		y = v.value - t.minLoan;
	setAttributes(_, {
		name: "deposit",
		id: "deposit",
		type: "number",
		step: "1",
		min: 0,
		value: depositValue
	});
	let L = document.createElement("label");
	L.setAttribute("for", "deposit"), L.innerHTML = "\xA3", L.appendChild(_), t.classes.input_wrapper && L.setAttribute("class", t.classes.input_wrapper);
	let E = document.createElement("span");
	E.classList.add("pbf_error_message"), E.id = "pbf_deposit_error";
	let C = document.createElement("div");
	if (C.classList.add("deposit_row"), C.appendChild(L), C.appendChild(E), o.deposit.appendChild(C), t.sliders) {
		let e = document.createElement("label");
		e.innerHTML = "Alternatively, use the slider to enter the deposit amount", o.deposit.appendChild(e);
		let t = document.createElement("input");
		setAttributes(t, {
			name: "depositSlider",
			id: "depositSlider",
			type: "range",
			step: "1"
		}), o.deposit.appendChild(t);
		let n = document.createElement("span");
		n.id = "depositRangeLabels", n.classList.add("rangeLabels"), n.innerHTML = "<span >\xA30</span><span>" + printNumber(y / 2) + "</span><span>" + printNumber(y) + "</span>", o.deposit.appendChild(n)
	}
	o.term = l.cloneNode(!0), o.term.classList.add("term-section");
	let S = document.createElement("label");
	S.innerHTML = t.labels.term, o.term.appendChild(S);
	let x = document.createElement("div");
	x.setAttribute("id", "term"), t.classes.button_list && x.setAttribute("class", t.classes.button_list), o.term.appendChild(x), Array.isArray(t.terms) ? (availableTerms = t.terms, multiTerm = !1) : "object" == typeof t.terms && (availableTerms = Object.keys(t.terms), multiTerm = !0);
	var A = !1;
	availableTerms.forEach(function(e) {
		e = parseFloat(e), e == sessionStorage.getItem("pbf_term") && (A = !0)
	}), availableTerms.forEach(function(e, n) {
		if (e = parseFloat(e), 0 == n) var a = !0;
		else var a = !1;
		let i = document.createElement("div");
		t.classes.button_wrapper && i.classList.add("pbf_button_wrapper");
		let s = document.createElement("label");
		s.innerHTML = e + " Months";
		let r = document.createElement("input");
		t.terms[e] && (t.terms[e].minLoan && r.setAttribute("minLoan", t.terms[e].minLoan), t.terms[e].minDeposit && r.setAttribute("minDeposit", t.terms[e].minDeposit), t.terms[e].maxDeposit && r.setAttribute("maxDeposit", t.terms[e].maxDeposit), t.terms[e].maxLoan && r.setAttribute("maxLoan", t.terms[e].maxLoan)), setAttributes(r, {
			type: "radio",
			name: "term",
			value: e,
			onclick: "javascript:updateRadio(this)"
		}), t.classes.buttons && s.setAttribute("class", t.classes.buttons), r.style.display = "none", !A && a ? (r.setAttribute("checked", "checked"), s.classList.add("active")) : A && e == sessionStorage.getItem("pbf_term") && (r.setAttribute("checked", "checked"), s.classList.add("active")), s.prepend(r), i.appendChild(s), x.appendChild(i)
	}), o.deferralterm = l.cloneNode(!0), o.deferralterm.classList.add("deferralterm-section");
	let T = document.createElement("label");
	T.innerHTML = t.labels.deferralterm, o.deferralterm.appendChild(T);
	let k = document.createElement("div");
	if (k.setAttribute("id", "deferralterm"), t.classes.button_list && k.setAttribute("class", t.classes.button_list), o.deferralterm.appendChild(k), Array.isArray(t.deferralterms) ? (availabledeferralterms = t.deferralterms, multideferralterm = !1) : "object" == typeof t.deferralterms ? (availabledeferralterms = Object.keys(t.deferralterms), multideferralterm = !0) : availabledeferralterms = !1, availabledeferralterms) {
		var M = !1;
		availabledeferralterms.forEach(function(e) {
			e = parseFloat(e), e == sessionStorage.getItem("pbf_deferralterm") && (M = !0)
		}), availabledeferralterms.forEach(function(e, n) {
			if (0 == n) var a = !0;
			else var a = !1;
			let i = document.createElement("div");
			t.classes.button_wrapper && i.classList.add("pbf_button_wrapper");
			let s = document.createElement("label");
			s.innerHTML = e + " Months";
			let r = document.createElement("input"),
				l = null,
				o = null;
			t.deferralterms[e] ? (l = t.deferralterms[e].minLoan, o = t.deferralterms[e].minDeposit) : l = t.minLoan, r.setAttribute("minLoan", l), o && r.setAttribute("minDeposit", o), setAttributes(r, {
				type: "radio",
				name: "deferralterm",
				value: e,
				onclick: "javascript:updateRadio(this)"
			}), t.classes.buttons && s.setAttribute("class", t.classes.buttons), r.style.display = "none", !M && a ? (r.setAttribute("checked", "checked"), s.classList.add("active")) : M && e == sessionStorage.getItem("pbf_deferralterm") && (r.setAttribute("checked", "checked"), s.classList.add("active")), s.prepend(r), i.appendChild(s), k.appendChild(i)
		})
	}
	o.results = l.cloneNode(!0);
	let P = document.createElement("h3");
	P.innerHTML = t.labels.results, o.results.appendChild(P);
	let N = document.createElement("div");
	N.id = "results", t.classes.results_box && N.setAttribute("class", t.classes.results_box), t.colours && N.classList.add("dark-border");
	let w = document.createElement("span");
	w.innerHTML = "Monthly Repayment";
	let H = document.createElement("span");
	H.id = "instalmentResults", H.className = "result";
	let R = document.createElement("div");
	R.appendChild(w), R.appendChild(H);
	let F = document.createElement("span");
	F.innerHTML = "Total Charge for Credit";
	let q = document.createElement("span");
	q.id = "creditChargeResults", q.className = "result";
	let D = document.createElement("div");
	D.appendChild(F), D.appendChild(q);
	let B = document.createElement("span");
	B.innerHTML = "Total Amount Payable";
	let I = document.createElement("span");
	I.id = "totalResults", I.className = "result";
	let V = document.createElement("div");
	V.appendChild(B), V.appendChild(I);
	let O = document.createElement("span");
	O.innerHTML = "APR";
	let j = document.createElement("span");
	j.id = "aprResults", j.className = "result";
	let X = document.createElement("div");
	X.appendChild(O), X.appendChild(j);
	let z = document.createElement("span");
	z.innerHTML = "Loan Amount";
	let J = document.createElement("span");
	J.id = "loanResults", J.className = "result";
	let Y = document.createElement("div");
	Y.appendChild(z), Y.appendChild(J);
	let U = document.createElement("span");
	U.innerHTML = "Deposit Amount";
	let G = document.createElement("span");
	G.id = "depositResults", G.className = "result";
	let W = document.createElement("div");
	W.appendChild(U), W.appendChild(G), N.appendChild(R), N.appendChild(X), N.appendChild(W), N.appendChild(D), N.appendChild(Y), N.appendChild(V), o.results.appendChild(N), o.rep_example = l.cloneNode(!0), o.rep_example.classList.add("rep-example-section");

    // JR 22/09/23
    let xx = "<span style='background:#7D3CFF;font-weight:normal;display:inline-block;color:white;padding:0 6px;border-radius:3px;'>Low cost early repayment option</span> Pay the loan amount plus a £29 early settlement fee anytime within the first 12 months to settle the loan!";
  
	let K = document.createElement("span");
	K.innerHTML = xx + "<br /><br />" + "Representative example: Cash Price " + printNumber(t.rep_example.cash_price) + ", Deposit " + printNumber(t.rep_example.deposit) + ", Loan amount " + printNumber(t.rep_example.loan_amount) + ", " + t.rep_example.apr + "% APR representative, Interest rate " + t.rep_example.interest_rate + "% fixed, 12 month payment holiday followed by " + t.rep_example.term + " monthly repayments of " + printNumber(t.rep_example.instalment_amount) + ", Total term of loan agreement " + t.rep_example.total_term + " months, Total charge for credit " + printNumber(t.rep_example.credit_charge) + ", Total Amount payable " + printNumber(t.rep_example.total_amount_payable) + ".", o.rep_example.appendChild(K), o.broker_disclaimer = l.cloneNode(!0), o.broker_disclaimer.classList.add("broker-disclaimer-section");
	let Q = document.createElement("span");
	Q.innerHTML = "Total Amount Payable Includes Deposit Amount. The figures shown are an illustration based on the cost of goods. Final details including shipping and discounts where applicable will be displayed on the checkout page. Credit subject to status and affordability. Terms & Conditions Apply. " + t.retailer.FCARetailerName + " FRN:739677 trading as " + t.retailer.TradingName + " is a credit broker and is Authorised and Regulated by the Financial Conduct Authority. Credit is provided by Novuna Personal Finance, a trading style of Mitsubishi HC Capital UK PLC, authorised and regulated by the Financial Conduct Authority. Financial Services Register no. 704348. The register can be accessed through http://www.fca.org.uk\n", o.broker_disclaimer.appendChild(Q), o.rounding_warning = l.cloneNode(!0), o.rounding_warning.classList.add("rounding-warning-section");
	let Z = document.createElement("span");
	if (Z.innerHTML = "IMPORTANT: Novuna Personal Finance rounds down the monthly payments, which may result in your total amount payable being less than the total cash price.", o.rounding_warning.appendChild(Z), t.financeJsButton) {
		o.finance_js_button = l.cloneNode(!0);
		let e = document.createElement("span");
		e.innerHTML = "PaybyFinance";
		let n = document.createElement("button");
		n.id = "pbf-submit-button", n.type = "submit", n.classList.add("button"), n.classList.add("button--primary"), n.appendChild(e), o.finance_js_button.appendChild(n), n.addEventListener("click", function(n) {
			n.preventDefault(), submitForm(t);
			let e = document.querySelector(window.PBF_Calc.target + " #results"),
				a = null,
				i = s.querySelector(".deferral-section > #deferralterm label.active > input");
			i && (a = i.value);
			let r = {
				instalmentResults: e.querySelector("#instalmentResults").innerHTML,
				creditChargeResults: e.querySelector("#creditChargeResults").innerHTML,
				totalResults: e.querySelector("#totalResults").innerHTML,
				depositResults: e.querySelector("#depositResults").innerHTML,
				aprResults: e.querySelector("#aprResults").innerHTML,
				loanResults: e.querySelector("#loanResults").innerHTML,
				term: s.querySelector(".term-section > #term label.active > input").value,
				deferralterm: a,
				service: s.querySelector("#services > .pbf_button_wrapper > label.active > input").value
			};
			for (const e in r) {
				const t = document.createElement("input");
				t.type = "hidden", t.name = e, t.value = r[e], s.appendChild(t), sessionStorage.setItem("pbf_" + e, r[e])
			}
			t.financeJsButton()
		})
	}
	if (t.financeButton) {
		o.finance_button = l.cloneNode(!0);
		let e = document.createElement("span");
		e.innerHTML = "PaybyFinance";
		let n = document.createElement("button");
		n.id = "pbf-save-button", n.type = "submit", n.classList.add("button"), n.classList.add("button--primary"), n.appendChild(e), o.finance_button.appendChild(n), n.addEventListener("click", function(n) {
			n.preventDefault(), submitForm(t);
			let e = document.querySelector(window.PBF_Calc.target + " #results"),
				a = {
					instalmentResults: e.querySelector("#instalmentResults").innerHTML,
					creditChargeResults: e.querySelector("#creditChargeResults").innerHTML,
					totalResults: e.querySelector("#totalResults").innerHTML,
					depositResults: e.querySelector("#depositResults").innerHTML,
					aprResults: e.querySelector("#aprResults").innerHTML,
					loanResults: e.querySelector("#loanResults").innerHTML
				};
			if ("-%" == a.aprResults || "\xA3-" == a.loanResults) return void console.log("Invalid submission");
			for (const e in a) {
				const t = document.createElement("input");
				t.type = "hidden", t.name = e, t.value = a[e], s.appendChild(t)
			}
			const i = new XMLHttpRequest;
			s = document.querySelector(window.PBF_Calc.target + " > #pbf_calculator");
			var r = new FormData(s);
			document.querySelector("#pbf-save-button").setAttribute("disabled", "disabled"), i.open("POST", t.financeButton, !0), i.onload = function() {
				try {
					let e = JSON.parse(i.responseText);
					sessionStorage.setItem("pbf_hash", e.hash), window.location.href = e.redirect_to
				} catch (e) {
					document.querySelector("#pbf-save-button").removeAttribute("disabled")
				}
			}, i.onerror = function() {
				document.querySelector("#pbf-save-button").removeAttribute("disabled")
			}, i.send(r)
		})
	}
	s.appendChild(o.amount), s.appendChild(o.deposit), s.appendChild(o.service), availabledeferralterms && s.appendChild(o.deferralterm), s.appendChild(o.term), s.appendChild(o.results), 0 != t.apr && "" != t.apr && s.appendChild(o.rep_example), s.appendChild(o.broker_disclaimer), 0 == t.apr && "" != t.apr && s.appendChild(o.rounding_warning), t.financeButton && s.appendChild(o.finance_button), t.financeJsButton && s.appendChild(o.finance_js_button);
	let $ = s.querySelectorAll("input");
	$.forEach(function(e) {
		e.onchange = function() {
			submitForm(t, e)
		}
	}), s.settings = t, n && n.remove(), r.appendChild(s), n ? submitForm(t) : (invalidateResults(s), window.PBF_CalcResults = {
		amount: 0,
		deposit: 0,
		service: 0
	}, handlePreSubmit(s, t), amountError("")), t.sliders && initSliders(amountSlider, depositSlider, t)
}

function submitForm(e, t = !1) {
	let n = document.querySelector(window.PBF_Calc.target + " > #pbf_calculator");
	return validateInputs(n, t) ? (handlePreSubmit(n, e), !0) : (handleInvalidSubmit(n), !1)
}

function handleInvalidSubmit(e) {
	const t = new FormData(e);
	let n = {};
	for (const [a, i] of t.entries()) n[a] = i;
	showResults(n, !1)
}

function handlePreSubmit(e, t) {
	const n = new FormData(e);
	let a = {};
	for (const [i, s] of n.entries()) a[i] = s;
	window.PBF_Calc.form = e, calculateFinance(a, t)
}

function handleSubmit(e, t) {
	const n = new FormData(e);
	let a = {};
	for (const [i, s] of n.entries()) a[i] = s;
	window.PBF_Calc.form = e, calculateFinance(a, t)
}

function updateRadio(e) {
	let t = e.closest("div.pbf_form_group").querySelector("label.active");
	t.classList.remove("active");
	let n = e.closest("label");
	n.classList.add("active")
}

function updateService(e, t) {
	updateRadio(e);
	let n = rebuildSettings(t, e.value);
	createCalculatorMarkup(n)
}

function calculateFinance(e, t) {
	window.PBF_Calc.user = e, e.deposit || (e.deposit = 0), e.amount || (e.amount = 0), e.term || (e.term = Object.keys(window.PBF_Calc.terms)[0]), e.service || (e.service = 0), parseInt(e.term) || (e.term = t.terms[0]), e.deferralterm = e.deferralterm ? parseInt(e.deferralterm) : null;
	let n = Object.keys(t.services)[parseInt(e.service)];
	service = t.services[n];
	let a = {
			apr: parseFloat(service.apr),
			totalCashPrice: parseFloat(e.amount),
			cashDeposit: parseFloat(e.deposit),
			term: parseInt(e.term),
			deferPeriod: e.deferralterm,
			optionPeriod: null
		},
		i = {
			instalmentAmount: parseFloat(calculateInstalment(a)),
			totalAmountPayable: parseFloat(calculateTotalAmountPayable(a)),
			creditCharge: parseFloat(calculateTotalChargeForCredit(a)),
			amount: parseFloat(e.amount),
			deposit: parseFloat(e.deposit),
			apr: parseFloat(service.apr),
			rpm: parseFloat(calculateRPMFromAPR(a)),
			loan: e.amount - e.deposit
		};
	window.PBF_Calc.results = i, showResults(i)
}

function showResults(e, t = !0) {
	let n = document.querySelector(window.PBF_Calc.target + " #results"),
		a = n.querySelector("#instalmentResults"),
		i = n.querySelector("#creditChargeResults"),
		s = n.querySelector("#totalResults"),
		r = n.querySelector("#depositResults"),
		l = n.querySelector("#aprResults"),
		o = n.querySelector("#loanResults");
	if (!t) {
		a.innerHTML = "\xA3-", i.innerHTML = "\xA3-", s.innerHTML = "\xA3-", r.innerHTML = "\xA3-", l.innerHTML = "-%", o.innerHTML = "\xA3-"
	} else a.innerHTML = printNumber(e.instalmentAmount), i.innerHTML = printNumber(e.creditCharge), s.innerHTML = printNumber(e.totalAmountPayable), r.innerHTML = printNumber(e.deposit), l.innerHTML = e.apr + "%", o.innerHTML = printNumber(e.loan);
	checkTerms(e)
}

function checkTerms(e) {
	e || (e = {
		loan: 0,
		amount: 0,
		deposit: 0
	}), e.loan || (e.loan = e.amount - e.deposit);
	let t = document.querySelectorAll(".term-section input");
	t.forEach(function(t) {
		t.removeAttribute("disabled"), t.closest("label").classList.remove("disabled"), t.closest("label").removeAttribute("title"), (thisMinDeposit = t.getAttribute("minDeposit")) && e.deposit < e.amount * (thisMinDeposit / 100) && disableInput(t, "This option requires a minimum deposit amount of " + thisMinDeposit + "% (" + printNumber(e.amount * (thisMinDeposit / 100)) + ")"), (thisMinLoan = t.getAttribute("minLoan")) && e.loan < parseFloat(thisMinLoan) && disableInput(t, "This option requires a minimum loan amount of " + printNumber(thisMinLoan))
	})
}

function disableInput(e, t) {
	e.setAttribute("disabled", "disabled"), e.closest("label").classList.add("disabled"), e.closest("label").setAttribute("title", t)
}

function validateInputs(e, t) {
	var n = Number.EPSILON,
		a = Math.round;
	let i = e.querySelector("#amount"),
		s = e.querySelector("#deposit");
	var r = i.value;
	"" === r && (r = 0);
	let l = s.value;
	"" == l && (l = 0);
	let o = i.value - s.value,
		d = e.querySelector(".term-section > #term label.active > input"),
		u = !1;
	t && (u = t.closest("div").querySelector(".pbf_error_message"));
	let p = document.querySelector("#pbf_amount_error"),
		c = document.querySelector("#pbf_deposit_error"),
		m = d.getAttribute("maxLoan") ? parseFloat(d.getAttribute("maxLoan")) : e.settings.maxLoan ? parseFloat(e.settings.maxLoan) : parseFloat(e.settings.limits.maxLoan),
		b = d.getAttribute("minLoan") ? parseFloat(d.getAttribute("minLoan")) : e.settings.minLoan ? parseFloat(e.settings.minLoan) : parseFloat(e.settings.limits.minLoan),
		v = parseFloat(s.value) + parseFloat(b),
		g = d.getAttribute("minDeposit") ? parseFloat(d.getAttribute("minDeposit")) : e.settings.minDeposit ? parseFloat(e.settings.minDeposit) : parseFloat(e.settings.limits.minDeposit),
		h = r * (g / 100);
	h = a(100 * (h + n)) / 100;
	let _ = d.getAttribute("maxDeposit") ? parseFloat(d.getAttribute("maxDeposit")) : e.settings.maxDeposit ? parseFloat(e.settings.maxDeposit) : parseFloat(e.settings.limits.maxDeposit),
		y = r * (_ / 100);
	y = a(100 * (y + n)) / 100;
	let L = parseFloat(s.getAttribute("max")),
		E = parseFloat(s.getAttribute("min"));
	return (p.innerHTML = "", c.innerHTML = "", window.PBF_Limits = {
		minLoan: parseFloat(b),
		maxLoan: parseFloat(m),
		"minDeposit%": parseFloat(g),
		"maxDeposit%": parseFloat(_)
	}, e.settings.debug && console.log(window.PBF_Limits), r - l > m) ? (target = u ? u : p, target.innerHTML = "The maximum loan amount is <strong>" + printNumber(m) + "</strong>. Please lower the spend amount or increase your deposit.", invalidateResults(), e.settings.debug && console.log("INVALID: Loan amount (\xA3" + r + ") too high"), !1) : r - l < b ? (target = u ? u : p, target.innerHTML = "The Minimum Loan Amount for the options you have chosen is <strong>" + printNumber(b) + "</strong>. Please increase your spend amount, or lower your deposit.", invalidateResults(), e.settings.debug && console.log("INVALID: Loan amount (\xA3" + r + ") too low"), !1) : h && (parseFloat(s.value) < h || "" == s.value) ? (c.innerHTML = "The options you have selected require a minimum deposit of <strong>" + g + "% (" + printNumber(h) + ")</strong>", invalidateResults(), e.settings.debug && console.log("INVALID: Deposit amount (\xA3" + l + ") too low"), !1) : y && parseFloat(s.value) > y ? (c.innerHTML = "The options you have selected have a maximum deposit of <strong>" + _ + "% (" + printNumber(y) + ")</strong>", invalidateResults(), e.settings.debug && console.log("INVALID: Deposit amount (\xA3" + l + ") too high"), !1) : (window.PBF_CalcResults = {
		amount: r,
		deposit: l,
		service: window.PBF_Calc.selectedService
	}, e.settings.debug && console.log("VALID: Loan amount (" + r + "), Deposit amount (\xA3" + l + ")"), validateResults(), !0)
}

function invalidateResults() {
	let e = document.querySelector("#results");
	e.classList.add("invalid")
}

function validateResults() {
	let e = document.querySelector("#results");
	e.classList.contains("invalid") && e.classList.remove("invalid")
}

function amountError(e) {
	let t = document.querySelector("#pbf_amount_error");
	t.innerHTML = e
}

function depositError(e) {
	let t = document.querySelector("#pbf_deposit_error");
	t.innerHTML = e
}

function validateInput(e) {
	let t = parseFloat(e.getAttribute("min")),
		n = parseFloat(e.getAttribute("max")),
		a = parseFloat(e.value);
	return !(a > n) && !(a < t)
}

function updateAmount(e, t) {
	let n = document.querySelector("#amount"),
		a = parseFloat(e) - parseFloat(t.minLoan);
	if (n.value = e, t.sliders) {
		let n = document.querySelector("#amountSlider"),
			i = document.querySelector(".deposit-section .rangeSlider"),
			s = document.querySelector("#depositRangeLabels");
		n.rangeSlider.update({
			value: e
		}), resetDepositSlider(a), i.classList.remove("rangeSlider--disabled"), parseFloat(e) === parseFloat(t.minLoan) && (i.classList.add("rangeSlider--disabled"), s.innerHTML = "")
	}
}

function setInput(e, t) {
	e.value = t
}

function setSlider(e, t) {
	e.rangeSlider.update({
		value: t
	})
}

function resetDeposit(e) {
	let t = document.querySelector("#deposit");
	t.setAttribute("max", e), setInput(t, 0)
}

function resetDepositSlider(e) {
	let t = document.querySelector("#depositSlider"),
		n = document.querySelector("#depositRangeLabels");
	n.innerHTML = "<span >\xA30</span><span>" + printNumber(e / 2) + "</span><span>" + printNumber(e) + "</span>", t.rangeSlider.update({
		max: e,
		value: 0
	})
}

function updateDeposit(e, t) {
	let n = document.querySelector("#deposit"),
		a = n.getAttribute("max");
	if (n.value = e, t.sliders) {
		let e = document.querySelector("#depositSlider");
		e.rangeSlider.update({
			value: n.value
		}), depositRangeLabels.innerHTML = "<span >\xA30</span><span>" + printNumber(a / 2) + "</span><span>" + printNumber(a) + "</span>"
	}
}

function loadConfigJSON(e) {
	if (e.inline_config) {
		var t = JSON.parse(e.inline_config);
		return void mergeSettings(t, e)
	}
	var n = new XMLHttpRequest;
	n.onreadystatechange = function() {
		if (4 == this.readyState && 200 == this.status) {
			var t = JSON.parse(this.responseText);
			mergeSettings(t, e)
		}
	}, n.open("GET", e.config, !0), n.send()
}